import { render } from "./ZipCodeForm.vue?vue&type=template&id=1253144f&ts=true"
import script from "./ZipCodeForm.vue?vue&type=script&lang=ts"
export * from "./ZipCodeForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__